import { FC, ReactElement, useEffect } from "react"

import { useAppSelector } from "../core/app/hooks"
import { RootState } from "../core/app/store"
import { canAll } from "../core/utils/access/access"
import { useFeatureFlag } from "../hooks/useFeatureFlag"
import { useMyNavigation } from "../hooks/useMyNavigation"

interface AuthorizeRouteProps {
  component: ReactElement
  /** Pre-computed authorization result — overrides allowedPermissions + featureFlag checks. */
  isAuthorized?: boolean
  allowedPermissions?: string | string[]
  featureFlag?: string
}

const AuthorizeRoute: FC<AuthorizeRouteProps> = ({
  component,
  isAuthorized: isAuthorizedProp,
  allowedPermissions,
  featureFlag,
}) => {
  const navigate = useMyNavigation()
  const { user } = useAppSelector((state: RootState) => state.userService)
  const isFlagEnabled = useFeatureFlag(featureFlag ?? "")

  const isPermissionAuthorized = allowedPermissions
    ? canAll(user?.app_permissions || [])(allowedPermissions)
    : true

  const isAuthorized =
    isAuthorizedProp ??
    (isPermissionAuthorized && (featureFlag ? isFlagEnabled : true))

  useEffect(() => {
    if (!isAuthorized) {
      navigate(user?.isAllowToViewAllOrg ? "/organization" : "/patients")
    }
  }, [isAuthorized, navigate])

  if (!isAuthorized) {
    return null
  }

  return component
}

export default AuthorizeRoute
